import { render } from "./light_lux.vue?vue&type=template&id=628dbb40&scoped=true"
import script from "./light_lux.vue?vue&type=script&lang=js"
export * from "./light_lux.vue?vue&type=script&lang=js"

import "./light_lux.vue?vue&type=style&index=0&id=628dbb40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-628dbb40"]])

export default __exports__